import { useEffect } from 'react';
import { throttle } from 'lodash';

export const useOnScroll = <T>(
  el: HTMLElement | null,
  onScroll: (event: Event) => void,
  wait?: number,
) => {
  const cb = throttle(onScroll, wait);

  useEffect(() => {
    if (!el) return;
    el.addEventListener('scroll', cb, true);
    return () => {
      el.removeEventListener('scroll', cb, true);
    };
  }, [el, onScroll]);
};
